export default function Hero() {
  return (
    <section id="hero" className="relative w-full flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Dark%20elegant%20Caribbean%20restaurant%20interior%20at%20night%20with%20warm%20golden%20candlelight%20and%20crystal%20chandeliers%2C%20rich%20wood%20tables%2C%20moody%20ambient%20lighting%2C%20luxury%20dining%20atmosphere%2C%20deep%20charcoal%20and%20gold%20tones%2C%20cinematic%20photography&width=1600&height=900&seq=berties-hero-bg&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/75 via-background-50/45 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl px-4 md:px-6 py-32 md:py-40 text-center">
        <p className="text-xs md:text-sm uppercase tracking-[0.4em] text-primary-500/90 mb-5 animate-fade-up">
          Welcome to
        </p>
        <h1 className="font-heading text-5xl md:text-7xl font-semibold leading-tight text-foreground-50 animate-fade-up">
          Bertie&rsquo;s Restaurant
          <br />
          <span className="italic font-medium">&amp; Cocktails</span>
        </h1>

        <div className="flex items-center justify-center gap-3 my-7 animate-fade-up">
          <span className="h-px w-16 bg-primary-500/50"></span>
          <span className="text-primary-500">✦</span>
          <span className="h-px w-16 bg-primary-500/50"></span>
        </div>

        <p className="text-lg md:text-2xl font-medium text-foreground-50 animate-fade-up">
          Taste the Flavors of the Caribbean
        </p>
        <p className="mt-3 text-sm md:text-base text-foreground-200/90 max-w-xl mx-auto animate-fade-up">
          Experience exceptional authentic Caribbean cuisine and craft cocktails in an atmosphere
          that celebrates the art of elegant dining.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-up">
          <span className="text-xs uppercase tracking-[0.3em] px-4 py-2 rounded-full border border-primary-500/60 text-primary-500">
            Now Open!
          </span>
          <a
            href="#menu"
            className="whitespace-nowrap text-sm font-semibold px-7 py-3 rounded-full text-background-950 bg-primary-500 hover:bg-primary-400 transition-colors"
          >
            Explore Menu
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.3em] text-foreground-200/70">Scroll</span>
        <span className="h-10 w-px bg-gradient-to-b from-primary-500 to-transparent"></span>
      </div>
    </section>
  );
}